
import props from './props.js'
export default {
  props,
  data() {
    return {
      selected: this.defaultValue,
      show: true,
    }
  },
  computed: {
    finalList() {
      if (this.disabled || this.disabledIfNoParentValue) return []

      const parentName = this.props.relation?.relatedFieldName
      const parentValue = this.props.relation?.watcher?.value
      const formattedOptions = this.options.reduce(
        (prev, { parentKey, key, content }) => {
          if (
            !parentName ||
            !parentValue ||
            !parentKey ||
            parentKey === parentValue ||
            (Array.isArray(parentValue) && parentValue.includes(parentKey))
          ) {
            return [...prev, { value: key, text: content }]
          }
          return prev
        },
        [],
      )

      return formattedOptions
    },
  },
  watch: {
    selected: {
      handler(newValue) {
        if (this.changeable || this.changeable === '')
          this.$set(this.changeable, 'value', newValue)
      },
    },
  },
  mounted() {
    if (this.props?.relation) {
      this.$watch(
        'props.relation.watcher.value',
        (newValue) => {
          if (this.props.relation.stateBefore === 'hidden') {
            this.show = newValue?.length > 0 || newValue === true
          }
        },
        {
          immediate: true,
        },
      )
    }
  },
}
